// frontend/src/app/utils/_apiInstance.ts
import axios from "axios";
import { EXTERNAL_LOGIN_URL } from "../consts";

const getStoredToken = () => localStorage.getItem("token") || null;

/**
 * API pública (sem token)
 * Usa URL relativa → passa pelo Nginx (/api)
 */
export const apiInstancePublic = axios.create({
  baseURL: "/api/lex/produto/v1",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

/**
 * API autenticada (com token)
 */
export const apiInstance = axios.create({
  baseURL: "/api/lex/produto/v1",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

/**
 * Interceptor de REQUEST
 * Injeta o Bearer Token automaticamente
 */
apiInstance.interceptors.request.use(
  (config) => {
    const token = getStoredToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Interceptor de RESPONSE
 * Trata erro de auth e servidor
 */
apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // Token inválido / expirado
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = EXTERNAL_LOGIN_URL;
      }

      // Erro de servidor
      if (status >= 500) {
        console.error("Erro no servidor:", error.response.data);
      }
    } else if (error.code === "ECONNABORTED") {
      console.error("Tempo limite da requisição excedido.");
    }

    return Promise.reject(error);
  }
);
